module.exports = __webpack_public_path__ + "static/img/logo.22daba5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/web/logo.png
// module id = HzeT
// module chunks = 0